// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.challenge-game-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  min-height: 100vh;
  background: #f5f5f5;
}

.game-header {
  text-align: center;
  margin-bottom: 30px;
  color: #333;
}

.game-header h1 {
  margin: 0 0 15px 0;
  font-size: 28px;
}

.series-info {
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 16px;
  font-weight: 600;
}

.series-info span {
  padding: 8px 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.game-counter {
  color: #667eea;
}

.wager {
  color: #e74c3c;
}

.series-complete-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 40px 20px;
  border-radius: 12px;
  text-align: center;
  margin-bottom: 20px;
}

.series-complete-banner h2 {
  margin: 0 0 10px 0;
  font-size: 24px;
}

.series-complete-banner p {
  margin: 0 0 20px 0;
  opacity: 0.9;
}

.series-complete-banner button {
  background: white;
  color: #667eea;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.series-complete-banner button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.game-content {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.series-score {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
}

.score-card {
  flex: 1 1;
  text-align: center;
  background: white;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.score-name {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.score-value {
  font-size: 36px;
  font-weight: 700;
  color: #667eea;
}

.score-divider {
  font-size: 24px;
  color: #ddd;
  font-weight: 300;
}

.ties-badge {
  padding: 8px 12px;
  background: #ffd700;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

.game-board {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 350px;
  gap: 20px;
}

.waiting-state,
.rolling-state,
.ready-state,
.rolled-state,
.result-state {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.spinner {
  font-size: 60px;
  animation: spin 5s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.waiting-state p,
.rolling-state p,
.ready-state p {
  font-size: 16px;
  color: #666;
  margin: 0;
}

.ready-state {
  gap: 30px;
}

.ready-state p {
  color: #27ae60;
  font-weight: 600;
}

.rolled-state {
  gap: 20px;
}

.rolled-state p {
  color: #666;
  margin: 0;
}

.your-roll,
.opponent-roll {
  text-align: center;
}

.your-roll h3,
.opponent-roll h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 16px;
}

.dice-value {
  font-size: 60px;
  font-weight: 700;
  color: #667eea;
  line-height: 1;
}

.rolls {
  display: flex;
  gap: 40px;
  justify-content: center;
  width: 100%;
}

.your-roll {
  flex: 1 1;
}

.opponent-roll {
  flex: 1 1;
}

.result-message {
  width: 100%;
  text-align: center;
  padding: 20px;
  border-radius: 8px;
  margin: 20px 0;
}

.result-message.win {
  background: #d4edda;
  border: 2px solid #28a745;
}

.result-message.win h2 {
  color: #155724;
  margin: 0;
}

.result-message.loss {
  background: #f8d7da;
  border: 2px solid #f5576c;
}

.result-message.loss h2 {
  color: #721c24;
  margin: 0;
}

.result-message.tie {
  background: #fff3cd;
  border: 2px solid #ffc107;
}

.result-message.tie h2 {
  color: #856404;
  margin: 0;
}

.roll-btn,
.next-btn,
.finish-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.roll-btn:hover,
.next-btn:hover,
.finish-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.4);
}

.roll-btn:active,
.next-btn:active,
.finish-btn:active {
  transform: translateY(0);
}

.next-btn,
.finish-btn {
  margin-top: 20px;
}

.finish-btn {
  background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
}

.finish-btn:hover {
  box-shadow: 0 6px 12px rgba(39, 174, 96, 0.4);
}

.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 12px 15px;
  border-radius: 8px;
  margin-top: 20px;
}

@media (max-width: 600px) {
  .series-info {
    flex-direction: column;
    gap: 10px;
  }

  .score-card {
    flex: 0 1;
  }

  .rolls {
    flex-direction: column;
    gap: 20px;
  }

  .dice-value {
    font-size: 48px;
  }

  .spinner {
    font-size: 48px;
  }
}

.forfeit-btn {
  background-color: #dc3545;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.2s;
  margin-top: 10px;
}

.forfeit-btn:hover {
  background-color: #c82333;
}

.forfeit-btn:active {
  transform: scale(0.98);
}
`, "",{"version":3,"sources":["webpack://./src/styles/ChallengeGame.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;;;;EAKE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;;;EAGE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;;;EAGE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".challenge-game-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  min-height: 100vh;\n  background: #f5f5f5;\n}\n\n.game-header {\n  text-align: center;\n  margin-bottom: 30px;\n  color: #333;\n}\n\n.game-header h1 {\n  margin: 0 0 15px 0;\n  font-size: 28px;\n}\n\n.series-info {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.series-info span {\n  padding: 8px 16px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.game-counter {\n  color: #667eea;\n}\n\n.wager {\n  color: #e74c3c;\n}\n\n.series-complete-banner {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 40px 20px;\n  border-radius: 12px;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.series-complete-banner h2 {\n  margin: 0 0 10px 0;\n  font-size: 24px;\n}\n\n.series-complete-banner p {\n  margin: 0 0 20px 0;\n  opacity: 0.9;\n}\n\n.series-complete-banner button {\n  background: white;\n  color: #667eea;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.series-complete-banner button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.game-content {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);\n}\n\n.series-score {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f9f9f9;\n  border-radius: 8px;\n}\n\n.score-card {\n  flex: 1;\n  text-align: center;\n  background: white;\n  padding: 15px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.score-name {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.score-value {\n  font-size: 36px;\n  font-weight: 700;\n  color: #667eea;\n}\n\n.score-divider {\n  font-size: 24px;\n  color: #ddd;\n  font-weight: 300;\n}\n\n.ties-badge {\n  padding: 8px 12px;\n  background: #ffd700;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #333;\n}\n\n.game-board {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 350px;\n  gap: 20px;\n}\n\n.waiting-state,\n.rolling-state,\n.ready-state,\n.rolled-state,\n.result-state {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n}\n\n.spinner {\n  font-size: 60px;\n  animation: spin 5s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.waiting-state p,\n.rolling-state p,\n.ready-state p {\n  font-size: 16px;\n  color: #666;\n  margin: 0;\n}\n\n.ready-state {\n  gap: 30px;\n}\n\n.ready-state p {\n  color: #27ae60;\n  font-weight: 600;\n}\n\n.rolled-state {\n  gap: 20px;\n}\n\n.rolled-state p {\n  color: #666;\n  margin: 0;\n}\n\n.your-roll,\n.opponent-roll {\n  text-align: center;\n}\n\n.your-roll h3,\n.opponent-roll h3 {\n  margin: 0 0 10px 0;\n  color: #333;\n  font-size: 16px;\n}\n\n.dice-value {\n  font-size: 60px;\n  font-weight: 700;\n  color: #667eea;\n  line-height: 1;\n}\n\n.rolls {\n  display: flex;\n  gap: 40px;\n  justify-content: center;\n  width: 100%;\n}\n\n.your-roll {\n  flex: 1;\n}\n\n.opponent-roll {\n  flex: 1;\n}\n\n.result-message {\n  width: 100%;\n  text-align: center;\n  padding: 20px;\n  border-radius: 8px;\n  margin: 20px 0;\n}\n\n.result-message.win {\n  background: #d4edda;\n  border: 2px solid #28a745;\n}\n\n.result-message.win h2 {\n  color: #155724;\n  margin: 0;\n}\n\n.result-message.loss {\n  background: #f8d7da;\n  border: 2px solid #f5576c;\n}\n\n.result-message.loss h2 {\n  color: #721c24;\n  margin: 0;\n}\n\n.result-message.tie {\n  background: #fff3cd;\n  border: 2px solid #ffc107;\n}\n\n.result-message.tie h2 {\n  color: #856404;\n  margin: 0;\n}\n\n.roll-btn,\n.next-btn,\n.finish-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 14px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.roll-btn:hover,\n.next-btn:hover,\n.finish-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.4);\n}\n\n.roll-btn:active,\n.next-btn:active,\n.finish-btn:active {\n  transform: translateY(0);\n}\n\n.next-btn,\n.finish-btn {\n  margin-top: 20px;\n}\n\n.finish-btn {\n  background: linear-gradient(135deg, #27ae60 0%, #229954 100%);\n}\n\n.finish-btn:hover {\n  box-shadow: 0 6px 12px rgba(39, 174, 96, 0.4);\n}\n\n.error-message {\n  background: #fee;\n  border: 1px solid #fcc;\n  color: #c33;\n  padding: 12px 15px;\n  border-radius: 8px;\n  margin-top: 20px;\n}\n\n@media (max-width: 600px) {\n  .series-info {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .score-card {\n    flex: 0;\n  }\n\n  .rolls {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .dice-value {\n    font-size: 48px;\n  }\n\n  .spinner {\n    font-size: 48px;\n  }\n}\n\n.forfeit-btn {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background-color 0.2s;\n  margin-top: 10px;\n}\n\n.forfeit-btn:hover {\n  background-color: #c82333;\n}\n\n.forfeit-btn:active {\n  transform: scale(0.98);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
